// @flow
import { getCountryName } from 'utils/internationalization';
import googleMaps from 'utils/googleMaps';

export const getCityStateString = (address: Object) =>
  [
    address.city,
    address.stateCode,
    address.country === 'US' ? null : getCountryName(address.country)
  ]
    .filter(part => part)
    .join(', ');

export const getAddressString = (address: Object) => {
  let addressString = [
    address.line1,
    address.line2,
    address.city,
    address.stateCode
  ]
    .filter(part => part)
    .join(', ');

  if (address.zipcode) {
    addressString += ` ${address.zipcode}`;
  }
  if (address.country !== 'US') {
    addressString += `, ${address.country}`;
  }
  return addressString;
};

const compareNoCase = (s1: string, s2: string) =>
  s1 && s2 ? s1.toLowerCase() === s2.toLowerCase() : s1 === s2;

export const lookupAddress = ({
  textQuery,
  addressData
}: {|
  textQuery: string,
  addressData: Object
|}) =>
  // Convert google maps callback into a promise
  new Promise<Object>((resolve, reject) => {
    googleMaps()
      .then(maps => {
        new maps.Geocoder().geocode(
          {
            address: textQuery,
            componentRestrictions: {
              country: addressData.country || []
            }
          },
          results => {
            // prevent results that could have come back later from overriding this.

            const update = {};
            if (results && results.length > 0) {
              const result = results[0];

              if (['US', 'CA'].includes(addressData.country)) {
                const stateComponent = result.address_components.find(c =>
                  c.types.includes('administrative_area_level_1')
                );
                if (
                  stateComponent &&
                  (compareNoCase(stateComponent.long_name, addressData.state) ||
                    compareNoCase(stateComponent.short_name, addressData.state))
                ) {
                  // Only update the address if there is a valid state / province
                  update.stateCode = stateComponent.short_name;
                  update.latitude = result.geometry.location.lat();
                  update.longitude = result.geometry.location.lng();
                  update.latLongAddress = result.formatted_address;
                  update.full = result.formatted_address;
                }
              } else {
                update.latitude = result.geometry.location.lat();
                update.longitude = result.geometry.location.lng();
                update.latLongAddress = result.formatted_address;
                update.full = result.formatted_address;
              }
            }
            resolve(update);
          }
        );
      })
      .catch(error => {
        reject(error.message);
      });
  });
